/* eslint-disable prettier/prettier */ 'use client';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ErrorTooltip } from '@whitbread-eos/atoms/ui';
import { useTranslation, cn } from '@whitbread-eos/utils/server';
import Image from 'next/image';
import { useRef } from 'react';
const LocationInput = ({ location, onChange, placeholder, locationIcon, clearIcon, onBlur, onFocus, errorIcon, showError })=>{
    const inputRef = useRef(null);
    const { t } = useTranslation();
    const handleClear = (e)=>{
        e.preventDefault();
        onChange('');
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            inputRef.current.focus();
        }
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: locationContainerStyle,
                "data-testid": "IB-Location-Container",
                children: [
                    /*#__PURE__*/ _jsx(Image, {
                        className: locationIconStyle,
                        src: locationIcon,
                        alt: 'Location Image',
                        width: 24,
                        height: 24
                    }),
                    /*#__PURE__*/ _jsx(ErrorTooltip, {
                        icon: errorIcon,
                        className: errorTooltipStyle,
                        content: t('content.form.invalidLocation'),
                        open: showError,
                        testId: "IB-Location-ErrorTooltip",
                        children: /*#__PURE__*/ _jsx("input", {
                            ref: inputRef,
                            className: cn(inputStyle, showError ? errorStyle : inputOutlineStyle),
                            placeholder: placeholder,
                            value: location,
                            onChange: (e)=>{
                                var _e_target;
                                return onChange(e === null || e === void 0 ? void 0 : (_e_target = e.target) === null || _e_target === void 0 ? void 0 : _e_target.value);
                            },
                            "data-testid": "IB-Location-Input",
                            onBlur: ()=>onBlur(),
                            onFocus: ()=>onFocus()
                        })
                    }),
                    /*#__PURE__*/ _jsx(Image, {
                        className: `${clearIconStyle} ${location ? 'peer-focus:visible peer-focus:w-6 peer-focus:h-6' : ''}`,
                        src: clearIcon,
                        alt: 'Location Clear',
                        width: 24,
                        height: 24,
                        onMouseDown: (e)=>handleClear(e),
                        "data-testid": "IB-Location-Clear"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(ErrorTooltip, {
                icon: errorIcon,
                content: t('content.form.invalidLocation'),
                open: showError,
                testId: "IB-Location-ErrorTooltip-Mobile",
                mobile: true
            })
        ]
    });
};
export default LocationInput;
const locationContainerStyle = 'relative flex justify-center items-center min-w-60 tablet:min-w-40 mobile:w-full';
const inputStyle = 'peer truncate h-14 w-full text-darkGrey1 border-lightGrey2 rounded-l mobile:rounded border bg-transparent p-4 pl-14 pr-14 text-base transition-colors placeholder:text-darkGrey2 z-[41] border-r-0 mobile:border-r-[1px]';
const locationIconStyle = 'absolute left-4 w-6 h-6 text-transparent z-40';
const clearIconStyle = 'absolute invisible w-0 h-0 right-4 text-transparent z-[42] cursor-pointer';
const inputOutlineStyle = 'focus:-outline-offset-2 focus:outline focus:outline-primaryColor focus:outline-2 hover:outline-1 hover:-outline-offset-1 hover:outline hover:outline-darkGrey1';
const errorStyle = '-outline-offset-2 outline outline-2 outline-error';
const errorTooltipStyle = 'max-w-[90%]';
